import React from "react";

import {
  Card,
  CardContent,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";

import { SelectField } from "react-admin";

import { UserStatuses } from "../../../utils/constants";
import { UserStatusIcon } from "../../../managerApp/resources/users/UserStatusIcon";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("sm")]: {
      width: "16em",
      minWidth: "16em",
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(0.5),
      overflow: "initial",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  statusIcon: {
    marginTop: theme.spacing(-0.3),
  },
}));

export const CustomerAside = ({ backPath, record, ...props }) => {
  const classes = useStyles();

  if (!record) return null;
  return (
    <Card className={classes.root}>
      <CardContent>
        <Grid container direction="column" spacing={1}>
          <Grid item xs={12}>
            <Typography variant="overline" color="textSecondary">
              Status:
            </Typography>
            <Grid container direction="row">
              <Grid item xs={2}>
                <UserStatusIcon record={record} classes={classes.statusIcon} />
              </Grid>
              <Grid item xs={10} className={classes.status}>
                <SelectField
                  source="status"
                  record={record}
                  choices={UserStatuses}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
